<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="50%"
    destroy-on-close
    @open="handleOpen"
    @close="handleClose"
  >
    <el-form
      label-width="120px"
      :rules="rules"
      :model="editForm"
      ref="editForm"
    >
      <el-form-item label="姓名" prop="realName">
        <el-input
          size="small"
          v-model="editForm.realName"
          auto-complete="off"
          placeholder="姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input
          size="small"
          v-model="editForm.phone"
          auto-complete="off"
          placeholder="手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="部门" prop="deptName">
        <el-input
          size="small"
          v-model="editForm.deptName"
          auto-complete="off"
          placeholder="部门"
          readonly
          ><el-button slot="append" type="primary" @click="handleParent"
            >请选择</el-button
          ></el-input
        >
      </el-form-item>
      <el-form-item label="角色" prop="roleId">
        <el-select size="small" v-model="editForm.roleId" placeholder="请选择">
          <el-option
            v-for="item of roleCols"
            :key="item.id"
            :label="item.roleName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="部门领导" prop="isLeader">
        <el-switch v-model="editForm.isLeader"> </el-switch>
      </el-form-item>
      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSubmit"
            >确定</el-button
          >
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <Dept
      :visible.sync="visibleDept"
      :userDept="true"
      @confirm="handleConfirmDept"
    ></Dept>
  </el-dialog>
</template>

<script>
import { selectRole } from "@/api/system/role";
import { saveOrUpdateUser } from "@/api/system/user";
import Dept from "@/views/components/dept";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: {
    Dept,
  },
  data() {
    return {
      roleCols: [],
      visibleDept: false,
      rules: {
        realName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        deptName: [{ required: true, message: "请选择部门", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1(3|4|5|6|7|8|9)\d\d{8,8}$/,
            required: true,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        /*
        userEmail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern:
              /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            required: true,
            message: "请输入正确的邮箱",
            trigger: "blur",
          },
        ],
        */
      },
    };
  },
  methods: {
    handleParent() {
      this.visibleDept = true;
    },
    getRole() {
      selectRole().then((data) => {
        data.unshift({ roleName: "空", id: "-1" });
        this.roleCols = data;
      });
    },
    handleConfirmDept(data) {
      this.editForm.deptId = data.id;
      this.editForm.deptName = data.deptName;
      this.$emit("update:editForm", this.editForm);
    },
    handleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editForm.status = 1;
          saveOrUpdateUser(this.editForm)
            .then(() => {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$emit("confirm");
              this.handleClose();
            })
            .catch(this.$message.warning);
        }
      });
    },
    handleOpen() {
      this.getRole();
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
    },
  },
};
</script>







// WEBPACK FOOTER //
// src/views/system/account/add-edit/index.vue